/**
 * Sticky-header-aware hash / anchor scrolling.
 * Ported from nulo-oxygen `app/root.jsx` (location.hash effect).
 */

/**
 * @returns {'smooth' | 'auto'}
 */
function scrollBehavior() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
}

/**
 * Scroll to the element matching the current URL hash, offset by the sticky header.
 */
function scrollToHash() {
  const { hash } = window.location;
  if (!hash || hash === '#') return;

  const anchor = decodeURIComponent(hash.slice(1));
  if (!anchor) return;

  const anchorEl = document.getElementById(anchor);
  if (!anchorEl) return;

  const header = document.querySelector('.primary-header');
  const headerOffset = header instanceof HTMLElement ? (header.offsetHeight + 10) : 0;
  const elementPosition = anchorEl.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.scrollY - headerOffset;

  window.scrollTo({
    top: Math.max(0, offsetPosition),
    behavior: scrollBehavior(),
  });
}

/**
 * Run after layout so sticky header height and target position are accurate.
 */
function scheduleScrollToHash() {
  requestAnimationFrame(scrollToHash);
}

scheduleScrollToHash();
window.addEventListener('hashchange', scheduleScrollToHash);
window.addEventListener('load', scheduleScrollToHash);
